module.exports = __webpack_public_path__ + "static/media/weather.4bf9c59e.jpg";